import { combineReducers } from 'redux';
import {
  DISMISS_ALERT,
  REQUEST_COMMENTS,
  RECEIVE_COMMENTS,
  RECEIVE_FEEDBACK_ERROR,
  RECEIVE_COMMENTS_CSV_REPORT_ASYNC,
} from '~src/actions/feedbackEngagementActions';

const dismissedAlert = {
  show: false,
};

function survey(
  state = {
    isFetching: false,
    filters: {},
    carriers: [],
    comments: [],
    total: 0,
    page: 0,
    alert: {
      show: false,
      color: '',
      text: '',
    },
  },
  action,
) {
  const update = {};
  switch (action.type) {
    case REQUEST_COMMENTS:
      update.isFetching = true;
      update.filters = action.filters;
      update.page = action.page;
      break;
    case RECEIVE_COMMENTS:
      update.isFetching = false;
      update.comments = action.comments;
      update.carriers = action.carriers;
      update.total = action.total;
      break;

    case RECEIVE_FEEDBACK_ERROR:
      update.isFetching = false;
      break;
    case RECEIVE_COMMENTS_CSV_REPORT_ASYNC:
      return {
        ...state,
        alert: {
          color:
            action.payload.response.status_code == 200 ? 'success' : 'danger',
          show: true,
          text:
            action.payload.response.status_code == 200
              ? 'Exporting analytics report via email.  Please wait about 10 minutes.'
              : 'Unable to request analytics report via email.  Please try again later.',
        },
      };
    case DISMISS_ALERT:
      update.alert = dismissedAlert;
      break;
    default:
      return state;
  }
  return { ...state, ...update };
}

const surveyCommentsReducer = combineReducers({ survey });

export default surveyCommentsReducer;
